import {
  createResource,
  postResource,
  dynamicUrl,
} from '../resources/resource'

import { ENDPOINTS } from '../resources/ENDPOINTS'


/** Communiti API */
export const postLoginCabinetAPI = createResource(
  ENDPOINTS.LOGIN,
  postResource
)
export const postLogoutCabinetAPI = createResource(
  ENDPOINTS.LOGOUT,
  postResource
)
export const postRestoreCabinetAPI = createResource(
  ENDPOINTS.RESTORE,
  postResource
)
export const postNewPassCabinetAPI = createResource(
  ENDPOINTS.NEW_PASSWORD,
  postResource
)


/** Statistics API */
export const getStatisticsAPI = dynamicUrl(
  ENDPOINTS.STATISTICS
)
export const getInfoWeekAPI = createResource(
  ENDPOINTS.WEEK_INFO
)
export const postSendSmsAPI = createResource(
  ENDPOINTS.SEND_SMS,
  postResource
)
export const getServicesAPI = createResource(
  ENDPOINTS.SERVICES
)
export const postCreateQuoteAPI = createResource(
  ENDPOINTS.CREATE_QUOTE,
  postResource
)
export const postCreateOrderAPI = createResource(
  ENDPOINTS.ORDER_CREATE,
  postResource
)
export const getResponsibleAPI = createResource(
  ENDPOINTS.EMPLOYEE
)

/** Order statistics API */
export const getOrderStatisticsAPI = dynamicUrl(
  ENDPOINTS.ORDER_STATISTICS
)
export const getManufacturerAPI = createResource(
  ENDPOINTS.MANUFACTURER
)
export const getModelsAPI = createResource(
  ENDPOINTS.MODEL_ITEMS
)


/** Orders API */
export const getOrdersHistoryAPI = dynamicUrl(
  ENDPOINTS.ORDERS_HISTORY
)
export const getOrdersStatusAPI = createResource(
  ENDPOINTS.ORDERS_STATUS
)


/** History API */
export const getBalanceHistoryAPI = dynamicUrl(
  ENDPOINTS.BALANCE_HISTORY
)
export const getBalanceDetailsAPI = createResource(
  ENDPOINTS.BALANCE_DETAILS
)


/** Withdraw API */
export const getDrawBalanceAPI = createResource(
  ENDPOINTS.DRAW_BALANCE
)
export const postDrawOutputAPI = createResource(
  ENDPOINTS.DRAW_OUTPUT,
  postResource
)
export const getDrawStatusAPI = createResource(
  ENDPOINTS.DRAW_STATUS
)
export const getDrawHistoryAPI = dynamicUrl(
  ENDPOINTS.DRAW_HISTORY
)


/** Settings API. */
export const getProfileCommonAPI = createResource(
  ENDPOINTS.PROFILE_INFO
)
export const postCommonChangeAPI = createResource(
  ENDPOINTS.COMMON_CHANGE,
  postResource
)
export const postEmailChangeAPI = createResource(
  ENDPOINTS.EMAIL_CHANGE,
  postResource
)
export const getTestEmailAPI = createResource(
  ENDPOINTS.TEST_EMAIL
)
export const postPassChangeAPI = createResource(
  ENDPOINTS.PASS_CHANGE,
  postResource
)



// WEBPACK FOOTER //
// ./src/js/services/cabinet.js